
import { computed, defineComponent } from 'vue'
import { useCheckout } from '@/composables/checkout/useCheckout'
import MultiSelect from '@vueform/multiselect'

export default defineComponent({
  components: {
    MultiSelect,
  },

  setup () {
    const {
      isLoaded,
      installments: installmentsOptions,
      checkoutFormData,
      updateCheckoutFormData
    } = useCheckout()

    const installments = computed({
      get: () => checkoutFormData.value.installments,
      set: (value) => updateCheckoutFormData({installments: value})
    })

    return {
      isLoaded,
      installments,
      installmentsOptions
    }
  }
})
